import { round } from 'lodash-es';
import * as userTestConstants from '../constants/userTest';
import { getCurrentOverlayScreen, getCurrentScale, getCurrentScreen, getRenderedScreenDimensions, getScreenStyles, } from '../selectors';
import { getLayerDOMElement } from './userTest';
// Utils to transform between viewport and image coordinates
// (We've got versions of this code all over the place, it be great to
// consolidate them all eventually ...)
// TODO have pure versions of these functions that don't rely on state and DOM
// inspection? (need to refactor layout.js etc to get sensible functions that
// tell us the positions and sizes of things -- still need DOM for scroll
// position tho)
export function viewportToImage(state, layer, coords) {
    var imageCoords = viewportToImageRaw(state, layer, coords);
    return [round(imageCoords.x), round(imageCoords.y)];
}
function viewportToImageRaw(state, layer, coords) {
    var scale = getScale(state);
    var relativeCoords = getRelativeEventPosition(state, coords, layer);
    if (layer.type === userTestConstants.SCROLL_CONTAINER_LAYER) {
        return viewportToScrollContainerImageCoords(relativeCoords, layer, scale);
    }
    var viewport = getRenderedScreenDimensions(state);
    var screen = layer.type === userTestConstants.SCREEN_LAYER
        ? getCurrentScreen(state)
        : getCurrentOverlayScreen(state);
    return viewportToScreenImageLayerCoords({
        screen: screen,
        relativeCoords: relativeCoords,
        layer: layer,
        scale: scale,
        viewport: viewport,
    });
}
function viewportToScrollContainerImageCoords(relativeCoords, layer, scale) {
    var layerElement = getLayerDOMElement(layer);
    return {
        x: relativeCoords.x / scale + layerElement.scrollLeft / scale,
        y: relativeCoords.y / scale + layerElement.scrollTop / scale,
    };
}
function viewportToScreenImageLayerCoords(_a) {
    var layer = _a.layer, screen = _a.screen, viewport = _a.viewport, relativeCoords = _a.relativeCoords, scale = _a.scale;
    if (screen.header && relativeCoords.y < screen.header.height * scale) {
        // in fixed header
        return { x: relativeCoords.x / scale, y: relativeCoords.y / scale };
    }
    if (screen.footer) {
        var footerY = viewport.height - scale * screen.footer.height;
        if (relativeCoords.y >= footerY) {
            // in fixed footer
            var y = (relativeCoords.y - footerY) / scale + screen.footer.y;
            return { x: relativeCoords.x / scale, y: y };
        }
    }
    // in body
    return {
        x: relativeCoords.x / scale,
        y: (relativeCoords.y + getLayerScrollPosition(layer)) / scale,
    };
}
function getRelativeEventPosition(state, _a, layer) {
    var x = _a.x, y = _a.y;
    var element = getLayerDOMElement(layer);
    var _b = element.getBoundingClientRect(), left = _b.left, top = _b.top;
    var relativeCoords = {
        x: x - left,
        y: y - top,
    };
    if (layer.type === userTestConstants.SCREEN_LAYER) {
        var marginLeft = getScreenStyles(state, true).imageMargin.marginLeft;
        // if the viewport is larger than the screen image then the screen component
        // is the full width of the viewport and the image is centred within it so
        // we need to subtract the left margin to get the correct x coordinate
        relativeCoords.x -= marginLeft;
    }
    return relativeCoords;
}
function getLayerScrollPosition(layer) {
    var element = getLayerDOMElement(layer);
    return element.scrollTop;
}
function getScale(state) {
    var scale = getCurrentScale(state);
    // TODO remove this hack to get actual scale value
    return scale(100000) / 100000;
}
